import { objectsMatch } from '@iotv/datamodel-core';
import React, { useEffect, useReducer } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export function useDocumentClientQuery({ query, queryParams, dependencies: [queryParamsHash], limit: limitIn, }) {
    /**
     * DEBUG state
     */
    const [lastQueryParamsHash, setLastQueryParamsHash] = React.useState(queryParamsHash);
    if (lastQueryParamsHash !== queryParamsHash) {
        setLastQueryParamsHash(queryParamsHash);
    }
    const [lastHashes, setLastHashes] = React.useState([]);
    const [completedHashes, setCompletedHashes] = React.useState([]);
    debug &&
        console.log(`useDocumentClientQuery queryParamsHash length`, {
            previous: lastQueryParamsHash?.length,
            current: queryParamsHash?.length,
            queryParams,
        });
    const [updates, forceUpdate] = useReducer((x) => {
        debug && console.log(`force update`, x + 1);
        return x + 1;
    }, 0);
    const [limit, setLimit] = React.useState(limitIn);
    const [inFlight, setInFlight] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [LastEvaluatedKey, setLastEvaluatedKey] = React.useState(undefined);
    const [LastEvaluatedKeys, setLastEvaluatedKeys] = React.useState([]);
    const [ExclusiveStartKey, setExclusiveStartKey] = React.useState(undefined);
    const excuteQuery = async (query, params, setterFn, hash) => {
        if (hash === undefined)
            return;
        debug && console.log('useDocumentClientQuery execute query with ', params);
        setInFlight(true);
        /** WARNING THIS WAS ADDED BY WYC WITHOUT CONSULTATION IT IS NOT A FIX FOR PAGINATION AN IS CONSIDERED TEMPORARY */
        let loopParams = params;
        let comb = {
            err: null,
            data: { Items: [], LastEvaluatedKey: undefined },
        };
        let current = [];
        let i = 0;
        do {
            const queryRes = await query(loopParams);
            if (queryRes.err !== null) {
                comb = queryRes;
            }
            else if (queryRes.data && queryRes.data.Items) {
                current.push(queryRes.data.Items);
                if (queryRes.data.LastEvaluatedKey === undefined) {
                    loopParams.ExclusiveStartKey = undefined;
                }
                else {
                    loopParams.ExclusiveStartKey = queryRes.data.LastEvaluatedKey;
                }
            }
            i++;
        } while (loopParams.ExclusiveStartKey !== undefined && i < 5);
        debug && console.log(`useDocumentClientQuery iterated ${i} times`, queryParams);
        if (comb.data)
            comb.data.Items = current.flat() ?? [];
        setInFlight(false);
        // fetch the latest query hash...
        const lastHash = lastHashes[lastHashes.length - 1];
        // mark this query as completed
        setCompletedHashes((hashes) => [...hashes, lastHash]);
        // if there are no stored hashes, this query cannot be valid, so we bail out
        if (lastHashes.length === 0)
            return;
        // check if it matches the hash of this query
        const match = lastHash == hash;
        debug && console.log(`useDocumentClientQuery hashes match? ${match}`, { lastHash, hash, lastHashes });
        // if this is the latest query, and we have data, set the data
        if (match && comb.data?.Items)
            setterFn(comb);
    };
    const setterFn = (result) => {
        debug && console.log('useDocumentClientQuery setter fn was  called with', result);
        if (result.data) {
            const data = result.data;
            if (data.Items) {
                setItems(data.Items);
            }
            debug && console.log('useDocumentClientQuery excuteQuery received LastEvaluatedKey', data.LastEvaluatedKey);
            setLastEvaluatedKey(data.LastEvaluatedKey);
            if (data.LastEvaluatedKey) {
                if (!LastEvaluatedKeys.find((key) => objectsMatch(key, data.LastEvaluatedKey))) {
                    const keys = [...LastEvaluatedKeys];
                    keys.push(data.LastEvaluatedKey);
                    setLastEvaluatedKeys(keys);
                }
            }
        }
        else if (result.err) {
            console.log('Err useDocumentClientQuery has err', result.err.message);
        }
    };
    useEffect(() => {
        debug && console.log('useDocumentClientQuery effect because', { queryParamsHash: queryParamsHash?.length });
        debug && console.log('useDocumentClientQuery queryParamas are', queryParams);
        if (queryParams) {
            // copy the current query hash
            const copiedHash = (' ' + queryParamsHash).slice(1);
            // add it to the current query hashes, filtering out all completed hashes
            setLastHashes((lh) => [...lh, (' ' + copiedHash).slice(1)].filter((hash) => !completedHashes.includes(hash)));
            // clear the completed hashes
            setCompletedHashes([]);
        }
    }, [lastQueryParamsHash, updates]);
    useEffect(() => {
        if (!queryParams)
            return;
        const mutatedParams = { ...queryParams, ExclusiveStartKey, limit };
        debug && console.log('useDocumentClientQuery calling with mutatedParams ', { query, setterFn, mutatedParams });
        // copy the current query hash
        // CRA note: why don't we recall the last hash from lastHashes?
        // CRA note: because then it doesn't work properly and every query will have a matching last hash
        const lastHash = (' ' + queryParamsHash).slice(1);
        debug && console.log('useDocumentClientQuery querying with', { lastHash, lastQueryParamsHash, queryParamsHash, lastHashes, completedHashes });
        // execute the query with the current hash
        excuteQuery(query, mutatedParams, setterFn, lastHash);
    }, [lastHashes]);
    return {
        querySetterGetters: [
            [items, setItems],
            [limit, setLimit],
            [LastEvaluatedKey, setLastEvaluatedKey],
            [LastEvaluatedKeys, setLastEvaluatedKeys],
            [ExclusiveStartKey, setExclusiveStartKey],
        ],
        forceUpdate,
        updates,
        inFlight,
    };
}
